import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

const BeforeAfter = ({ before, after }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const [dragging, setDragging] = useState(false);

  const update = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setPos(Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="relative w-full aspect-[16/10] select-none overflow-hidden cursor-ew-resize bg-surface"
      onPointerDown={(e) => {
        e.currentTarget.setPointerCapture(e.pointerId);
        setDragging(true);
        update(e.clientX);
      }}
      onPointerMove={(e) => dragging && update(e.clientX)}
      onPointerUp={() => setDragging(false)}
      onPointerCancel={() => setDragging(false)}
    >
      <img src={after} alt="Dopo — immagine finale" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt="Prima — immagine grezza" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      </div>
      <div className="absolute top-0 bottom-0 w-px bg-gold" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-night/80 border border-gold flex items-center justify-center text-gold backdrop-blur-sm">
          <ChevronsLeftRight size={18} />
        </span>
      </div>
      <span className="absolute top-4 left-4 text-[10px] font-mono tracking-[0.25em] text-bone bg-night/60 px-3 py-1.5">PRIMA</span>
      <span className="absolute top-4 right-4 text-[10px] font-mono tracking-[0.25em] text-bone bg-night/60 px-3 py-1.5">DOPO</span>
    </div>
  );
};

export default BeforeAfter;
